import { render, staticRenderFns } from "./StatePopupRectangleButton.vue?vue&type=template&id=1fb7c200&scoped=true"
import script from "./StatePopupRectangleButton.vue?vue&type=script&lang=js"
export * from "./StatePopupRectangleButton.vue?vue&type=script&lang=js"
import style0 from "./StatePopupRectangleButton.vue?vue&type=style&index=0&id=1fb7c200&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb7c200",
  null
  
)

export default component.exports